// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

import { Button } from '../../Button';
import { Modal } from '../../Modal';
import type { GameSummary } from '../../../types/game';

interface QuickSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  gameId: string;
  games: GameSummary[];
  submitting: boolean;
}

export function QuickSettingsModal({
  isOpen,
  onClose,
  onSubmit,
  gameId,
  games,
  submitting,
}: QuickSettingsModalProps) {
  const selectedGame = games.find(g => g.game_id === gameId);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create Room">
      <form onSubmit={onSubmit} className="space-y-6" data-testid="modal-quick-settings-form">
        {gameId && selectedGame && (
          <div
            className="p-4 rounded-lg"
            style={{
              backgroundColor: 'var(--color-surface-hover)',
              border: 'var(--neo-border-medium)',
            }}
          >
            <div className="font-bold text-lg mb-2" style={{ color: 'var(--color-text-primary)' }}>
              {selectedGame.display_name}
            </div>
            <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
              {selectedGame.description}
            </p>
            <div className="text-xs mt-2" style={{ color: 'var(--color-text-muted)' }}>
              👥 {selectedGame.min_players}-{selectedGame.max_players} players
            </div>
          </div>
        )}
        <div className="text-sm text-center" style={{ color: 'var(--color-text-secondary)' }}>
          Ready to create a room for this game?
        </div>
        <div className="flex gap-4">
          <Button
            type="submit"
            variant="success"
            disabled={submitting}
            className="flex-1"
            data-testid="modal-quick-settings-submit"
          >
            {submitting ? 'Creating...' : 'Create & Start'}
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            data-testid="modal-quick-settings-cancel"
          >
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  );
}
